export const organizationInfo = {
  organizationName: 'El Camino Medical Clinic',
  website: 'elcaminomed.com',
  npi: '1073841557',
  billingName: 'Henry J Low Medical Corp',
  taxId: '270793149',
  billingStreet: '6510 Lonetree Blvd Ste 300',
  city: 'Rocklin',
  state: 'California',
  zip: '95765'
};

export const practiceRows = [
  {
    id: 1,
    practiceName: 'El Camino Medical Clinic - Main',
    facilityNpi: '1073841557',
    phone: '(916) 672-6622',
    fax: '650-860-3269',
    address: '6510 Lonetree Blvd Ste 300, Rocklin, CA 95765',
    email: 'admin@elcaminomed.com'
  },
  {
    id: 2,
    practiceName: 'El Camino Medical Clinic - Downtown',
    facilityNpi: '1073841558',
    phone: '(916) 555-6678',
    fax: '650-860-3270',
    address: '3200 J Street, Suite 100, Sacramento, CA 95814',
    email: 'sacramento@elcaminomed.com'
  }
];